<template>
  <div class="header-wrapper lg:container relative flex flex-col">
    <div class="lg:mt-6 lg:w-11/12">
      <FixedAspect :ratio="2 / 3" class="relative">
        <CldnImg
          v-if="imageSrc"
          :src="imageSrc"
          sizes="100vw md:100vw lg:80vw xl:83vw 2xl:83vw"
          crop="fill"
          :alt="alt"
        />
      </FixedAspect>
    </div>
    <div class="box lg:w-10/12 lg:self-end lg:-mt-32 lg:p-24 z-10">
      <slot />
    </div>
  </div>
</template>

<script>
import FixedAspect from '@/components/common/FixedAspect';
import CldnImg from '@/components/CldnImg';

export default defineNuxtComponent({
  name: 'ArticleHeader',
  components: {
    FixedAspect,
    CldnImg,
  },
  props: {
    imageSrc: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
  },
});
</script>
